_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'views/custom-field/custom-field-card-detail-badge-view'
t = require('views/internal/teacup-with-helpers')('custom_fields')

module.exports = class CustomFieldListCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ idValue, icon, name, text, editable, options, color } = {}) ->
    t.h3 '.card-detail-item-header', { title: name }, ->
      t.icon icon
      t.text name

    if editable
      t.div '.list-detail-badge.custom-field-detail-badge.is-clickable.js-custom-field-detail-badge' + color, { title: text || t.l 'select' }, ->
        t.span '.js-custom-field-list-value', ->
          if text
            t.text text
          else
            t.format 'select'
            t.span '.icon-sm.icon-down.u-float-right'
        t.label name
        t.select '.js-custom-field-list', ->
          t.option { value: "", selected: !idValue? || !text }, -> "--"
          for { id, value } in options ? []
            t.option { value: id, selected: id == idValue }, ->
              t.text value.text
    else
      t.span '.custom-field-detail-badge' + color, { title: text }, ->
        t.text text

  events:
    'change .js-custom-field-list': 'editCustomFieldList'

  editCustomFieldList: (e) ->
    @track()
    if !@customFieldItem? && e.target.value
      @model.customFieldItemList.create({
        idCustomField: @customField.id
        idModel: @model.id
        modelType: 'card'
        idValue: e.target.value
        options: []
      })
      return

    if @customFieldItem && e.target.value == ''
      @customFieldItem.clearValue()
    else
      @customFieldItem.setValue(e.target.value)



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-list-card-detail-badge-view.coffee